export default __webpack_public_path__ + "static/andrew-671d30deb9b02dbe3040cee749d34b12.jpeg";